import * as angular from "angular";
import {IController} from "angular";


export class PlanningSelectProjectViewComponent implements IController {
  projectId: string;
  onProjectSelected: Function;

  public from: number;
  public to: number;

  constructor(private moment) {
  }

  $onInit() {
    this.from = this.moment().startOf('day').valueOf()
    this.to = this.moment().endOf('day').valueOf()
  }

  onRangeChange(from: number, to: number) {
    this.from = from;
    this.to = to;
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningSelectProjectView', {
    require: {
      form: '^form'
    },
    bindings: {
      projectId: '<',
      onProjectSelected: '&'

    },
    template: require('./planning-select-project-view.html').default,
    controller: PlanningSelectProjectViewComponent
  });

